export default "__VITE_ASSET__C$yaWYl5__ 400w, __VITE_ASSET__Dsku0zQO__ 800w, __VITE_ASSET__BuqxbdIt__ 1024w";